import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    shownav: true,
    routes: [],
    morningroute: null,
    afternoonroute: null,
    islogged: false,
    maininfo: {
      monitores: [],
      conductores: [],
      autobuses: [],
      user: null
    },
    rutactiva: localStorage.getItem("rutaactiva") || null,
    detalleruta: JSON.parse(localStorage.getItem("detalleruta")) || null,
    navBack: null
  },
  mutations: {
    SET_SHOWNAV(state, payload) {
      state.shownav = payload;
    },
    SET_ROUTES(state, payload) {
      state.routes = payload;
    },

    SET_MORNINGROUTE(state, payload) {
      state.morningroute = payload;
    },
    SET_AFTERNOONROUTE(state, payload) {
      state.afternoonroute = payload;
    },
    SET_MAININFO(state, payload) {
      state.maininfo = payload;
    },
    SET_ISLOGGED(state, payload) {
      state.islogged = payload;
    },
    SET_RUTACTIVA(state, payload) {
      localStorage.setItem("rutaactiva", payload);
      state.rutactiva = payload;
    },
    SET_DETALLERUTA(state, payload) {
      localStorage.setItem("detalleruta", JSON.stringify(payload));
      state.detalleruta = payload;
    },
    SET_NAVBACK(state, payload) {
      state.navBack = payload;
    }
  },
  getters: {
    shownav(state) {
      return state.shownav;
    },
    routes(state) {
      return state.routes;
    },
    morningroute(state) {
      return state.morningroute;
    },
    afternoonroute(state) {
      return state.afternoonroute;
    },
    islogged(state) {
      return state.islogged;
    },
    maininfo(state) {
      return state.maininfo;
    },
    rutactiva(state) {
      return state.rutactiva;
    },
    detalleruta(state) {
      return state.detalleruta;
    },
    navBack(state) {
      return state.navBack;
    }
  },
  actions: {
    GET_INFO(context) {
      axios.get("/api/maininfo").then(response => {
        context.commit("SET_MAININFO", response.data);
      });
    }
  },
  modules: {}
});
